import { faArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { Icon, Tag } from '@rocketlane/ui';
import { FormattedMessage } from 'react-intl';

type JumpToCurrentTimeProps = {
  isAutoScrollEnabled: boolean;
  enableAutoScrollToSegment: () => void;
};
export const JumpToCurrentTime = ({
  isAutoScrollEnabled,
  enableAutoScrollToSegment,
}: JumpToCurrentTimeProps) => {
  return (
    <Tag
      variant="basic"
      color="outline"
      height={32}
      onClick={enableAutoScrollToSegment}
      className={`absolute bottom-[8px] left-1/2 -translate-x-1/2 opacity-0 translate-y-full transition-[opacity,transform] duration-200 ease-in-out ${!isAutoScrollEnabled ? 'opacity-100 translate-y-0' : ''}`}
      style={{ boxShadow: 'var(--shadow-08)' }}
      icon={<Icon icon={faArrowUp} size={'1x'} />}
    >
      <span className="body-short-01">
        <FormattedMessage id="account.meeting_pages.transcript.auto_scroll_disabled" />
      </span>
    </Tag>
  );
};
